import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'ef3-integrates-linescape-data',
  template: require('./ef3-integrates-linescape-data.component.html'),
  styles: [require('./../blog.component.scss'), require('./ef3-integrates-linescape-data.component.scss')]
})
export class Ef3IntegratesLinescapeDataComponent extends BlogPage {


  title = "eF3 Systems Integrates Linescape Data - Linescape";
  description = "Las Vegas technology company combines Linescape's Schedule Data with their logistics and supply chain management software";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/ef3-integrates-linescape-data/ef3-integrates-linescape-data.component.ts